// extracted by mini-css-extract-plugin
module.exports = {"news":"topnews-module--news--3M3t5","news_label":"topnews-module--news_label--1nP7v","news_title":"topnews-module--news_title--3bwRj"};